import { Component, OnInit } from '@angular/core';
import { AbstractModal, ModalButtonModel, ModalButtonType } from '@cv-invision/core';
import { ProductIdentifierListService } from '../../service/product-identifier-list.service';
import { ProductIdentifierModel, ADD_EDIT_PRODUCT_IDENTIFIER } from '../../model/product-identifier.model';

@Component({
	selector: 'cv-product-identifier-list',
	templateUrl: './product-identifier-list.component.html'
})
export class ProductIdentifierList extends AbstractModal implements OnInit {
	ADD_EDIT_PRODUCT_IDENTIFIER = ADD_EDIT_PRODUCT_IDENTIFIER;

	public onDismiss(): void {
		super.onCancel();
	}

	public integrationName: string;

	constructor(public productService: ProductIdentifierListService) {
		super();
	}

	ngOnInit(): void {
		this.integrationName = this.data.integrationName;

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};

		this.buttons.push(cancelButton);
	}

	// These are passed into the GenericIdentifierListComponent as inputs
	getListFn = this.productService.getProductIdentifiersByIntegrationName.bind(this.productService);
	deleteFn = this.productService.deleteProductIdentifier.bind(this.productService);
	getSecondFieldValue = (model: ProductIdentifierModel) => model.id;
	modelFactory = () => new ProductIdentifierModel();
}
